import { createApi } from '@reduxjs/toolkit/query/react'
import { graphqlRequestBaseQuery } from '@rtk-query/graphql-request-base-query'
import { GraphQLClient } from 'graphql-request'
import { prepareHeaders } from '@/core/utils/prepareHeaders.ts'
import { redirectToLogin } from '@/core/utils/redirectToLogin.ts'
import { getApiUrl } from '@/core/utils/getApiUrl.ts'

export const baseGraphqlApi = createApi({
  baseQuery: graphqlRequestBaseQuery({
    client: new GraphQLClient(getApiUrl() + '/graphql'),
    customErrors: (error) => {
      if (error.response?.status === 401) {
        redirectToLogin()
      }

      return error
    },
    prepareHeaders,
  }),
  endpoints: () => ({}),
})
